import { c as _c } from "react/compiler-runtime";
import type { ProductInfoProduct, ProductInfoProductImage } from '@spa/components/product-info/ProductInfoProductTypes';
import React, { ReactNode } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import styles from './store-search.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface StoreSearchProductInfoComponentProps {
  readonly product: ProductInfoProduct;
}
export function StoreSearchProductInfoComponent(properties) {
  const $ = _c(17);
  const {
    product
  } = properties;
  const {
    images
  } = product;
  const productImage = images?.[0] ?? null;
  const {
    formatMessage
  } = useNamespacedIntl("storefinder");
  let t0;
  if ($[0] !== formatMessage || $[1] !== product.name || $[2] !== productImage) {
    t0 = productImage && <div className={styles["store-search__product-image-wrapper"]}><ImageComponent className={styles["store-search__product-image"]} src={productImage.url} width={productImage.width} height={productImage.height} alt={formatMessage("imageAlt", {
        productName: product.name
      })} /></div>;
    $[0] = formatMessage;
    $[1] = product.name;
    $[2] = productImage;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== product.name) {
    t1 = <span className="bold">{product.name}</span>;
    $[4] = product.name;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== formatMessage || $[7] !== product.code) {
    t2 = formatMessage("articleNumber", {
      code: product.code
    });
    $[6] = formatMessage;
    $[7] = product.code;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <span>{t2}</span>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <div className={styles["store-search__product-info"]}>{t1}{t3}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t0 || $[15] !== t4) {
    t5 = <div className={styles["store-search__product"]}>{t0}{t4}</div>;
    $[14] = t0;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}